"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierMetric = exports.DiscountTarget = exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "percentage";
    DiscountType["FIXED_AMOUNT"] = "fixed_amount";
    DiscountType["FIXED_PRICE"] = "fixed_price";
    DiscountType["TIERED"] = "tiered";
    DiscountType["BUY_X_GET_Y"] = "buy_x_get_y";
    DiscountType["BUNDLE"] = "bundle";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var DiscountTarget;
(function (DiscountTarget) {
    DiscountTarget["TOTAL_CART"] = "total_cart";
    DiscountTarget["SPECIFIC_ITEMS"] = "specific_items";
    DiscountTarget["CHEAPEST_ITEM"] = "cheapest_item";
    DiscountTarget["MOST_EXPENSIVE"] = "most_expensive";
})(DiscountTarget || (exports.DiscountTarget = DiscountTarget = {}));
var TierMetric;
(function (TierMetric) {
    TierMetric["CART_TOTAL"] = "cart_total";
    TierMetric["DISPLAYS_COUNT"] = "displays_count";
    TierMetric["PLAYS_COUNT"] = "plays_count";
    TierMetric["CAMPAIGN_DAYS"] = "campaign_days";
    TierMetric["TOTAL_HOURS"] = "total_hours";
})(TierMetric || (exports.TierMetric = TierMetric = {}));
